import {
  useAppDispatch,
  useAppSelector,
  choosePlanModalState,
  setLastTimeChoosePlanModalWasShown,
  setShouldShowChoosePlanModal,
  setNeverShowChoosePlanModalAgain,
} from 'src/store';
import { useCallback, useMemo } from 'react';
import { batch } from 'react-redux';
import dayjs from 'dayjs';

export const useChoosePlanModal = () => {
  const {
    shouldShowPlanModal,
    lastTimeModalWasShown,
    neverShowPlanModalAgain,
  } = useAppSelector(choosePlanModalState);
  const dispatch = useAppDispatch();

  const changeShouldShowPlanModal = useCallback(
    (value: boolean) => {
      dispatch(setShouldShowChoosePlanModal(value));
    },
    [dispatch],
  );

  const changeNeverShowChoosePlanModalAgain = useCallback(
    (value: boolean) => {
      dispatch(setNeverShowChoosePlanModalAgain(value));
    },
    [dispatch],
  );

  const changeLastTimeChoosePlanModalWasShown = useCallback(
    (value: Date | null) => {
      dispatch(setLastTimeChoosePlanModalWasShown(value));
    },
    [dispatch],
  );

  const changeChoosePlanModalState = useCallback(
    ({
      shouldShow,
      lastTimeWasShown,
    }: {
      shouldShow: boolean;
      lastTimeWasShown: Date | null;
    }) => {
      batch(() => {
        dispatch(setLastTimeChoosePlanModalWasShown(lastTimeWasShown));
        dispatch(setShouldShowChoosePlanModal(shouldShow));
      });
    },
    [dispatch],
  );

  const isTimeToShowPlanModal =
    (lastTimeModalWasShown === null ||
      dayjs().diff(dayjs(lastTimeModalWasShown), 'hour') >= 24) &&
    !shouldShowPlanModal;

  return useMemo(
    () => ({
      isTimeToShowPlanModal,
      shouldShowPlanModal,
      lastTimeModalWasShown,
      changeShouldShowPlanModal,
      changeLastTimeChoosePlanModalWasShown,
      changeChoosePlanModalState,
      changeNeverShowChoosePlanModalAgain,
      neverShowPlanModalAgain,
    }),
    [
      isTimeToShowPlanModal,
      shouldShowPlanModal,
      lastTimeModalWasShown,
      changeShouldShowPlanModal,
      changeLastTimeChoosePlanModalWasShown,
      changeChoosePlanModalState,
      changeNeverShowChoosePlanModalAgain,
      neverShowPlanModalAgain,
    ],
  );
};
